import React from 'react';
import { View, StyleSheet, Image } from 'react-native';
import { withTheme } from '../../core/theming';
import Text, { TextType } from '../Typography/Text';
import Card from '../Card';
import { iconArrowRight } from '../../assets';

const IconListItem = props => {
  const renderIcon = (icon, style) => {
    if (!icon) return null;
    return /*#__PURE__*/React.createElement(Image, {
      source: icon,
      style: style
    });
  };

  const chevron = props.chevron || iconArrowRight;
  const {
    isShadowDisplayed = true
  } = props;
  return /*#__PURE__*/React.createElement(Card, {
    isShadowDisplayed: isShadowDisplayed,
    onPress: props.onPress,
    style: [styles.view, props.style]
  }, /*#__PURE__*/React.createElement(View, {
    style: [styles.iconTitleView]
  }, props.icon && renderIcon(props.icon, props.iconStyle), /*#__PURE__*/React.createElement(View, {
    style: [styles.labelView]
  }, /*#__PURE__*/React.createElement(Text, {
    type: TextType.Subtitle
  }, props.title), !!props.subTitle && /*#__PURE__*/React.createElement(Text, {
    style: styles.subTitleView,
    type: TextType.Caption2
  }, props.subTitle))), renderIcon(chevron, styles.chevronStyle));
};

const styles = StyleSheet.create({
  view: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 12,
    paddingRight: 12,
    paddingLeft: 25
  },
  iconTitleView: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1
  },
  labelView: {
    flex: 1,
    marginLeft: 8
  },
  subTitleView: {
    marginTop: 4
  },
  chevronStyle: {
    alignSelf: 'center',
    height: 16,
    width: 11,
    marginLeft: 10
  }
});
export default withTheme(IconListItem);
//# sourceMappingURL=IconListItem.js.map